import { definePreset } from '@primeuix/themes';
import LARA_THEME from '@primeuix/themes/lara';

export const JOBFIXERS_THEME_PRESET = definePreset(LARA_THEME, {
  semantic: {
    primary: {
      '50': '#fefce5',
      '100': '#fdf7c0',
      '200': '#fcf296',
      '300': '#fbed6b',
      '400': '#f9e847',
      '500': '#F8D219',
      '600': '#f8d319',
      '700': '#f7bb0e',
      '800': '#f6a201',
      '900': '#f47700',
    },
    secondary: {
      '50': '#ffebef',
      '100': '#ffccd5',
      '200': '#f1979e',
      '300': '#e86e78',
      '400': '#f44957',
      '500': '#D91935',
      '600': '#eb263c',
      '700': '#d91936',
      '800': '#cc0d2e',
      '900': '#be0022',
    },
    purple: {
      '500': '#284d72',
    },
  },
  components: {
    slider: {
      range: {
        background: '{secondary-500}',
      },
      handle: {
        background: '{secondary-500}',
        content: {
          background: '{secondary-500} !important',
          hoverBackground: '{secondary-300} !important',
        },
      },
    },
    skeleton: {
      root: {
        animationBackground: '{secondary-100} !important',
      },
    },
  },
});
